import { useState } from "react";

export function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim() || formData.name.trim().length < 3) {
      newErrors.name = "Name must be at least 3 characters";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (formData.phone && formData.phone.trim()) {
      const phoneRegex = /^[+]?[\d\s()-]{10,}$/;
      if (!phoneRegex.test(formData.phone)) {
        newErrors.phone = "Please enter a valid phone number";
      }
    }

    if (!formData.message.trim() || formData.message.trim().length < 10) {
      newErrors.message = "Message must be at least 10 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    setIsSubmitting(true);

    const subject = encodeURIComponent("Thermal AI Detection Inquiry");
    const body = encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\n${formData.phone ? `Phone: ${formData.phone}\n` : ""}${formData.company ? `Company: ${formData.company}\n` : ""}\n\nMessage:\n${formData.message}`,
    );

    window.location.href = `mailto:contact@lastmileservice.in?subject=${subject}&body=${body}`;

    setTimeout(() => setIsSubmitting(false), 1000);
  };

  return (
    <div className="page-bg contact-bg">
      <div className="page-overlay">
        {/* Hero Section */}
        <div className="contact-hero bg-dark text-white py-5">
          <div className="container py-4">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center">
                <div className="mb-3">
                  <i
                    className="bi bi-chat-dots-fill text-warning"
                    style={{ fontSize: "3rem" }}
                  ></i>
                </div>
                <h1 className="display-4 fw-bold mb-3">Get In Touch</h1>
                <p className="lead mb-0">
                  Ready to bring your idea to life? Let's discuss your project
                  requirements
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="container py-5">
          <div className="row g-4 mt-2">
            {/* Contact Information */}
            <div className="col-lg-5 mb-4 mb-lg-0">
              <div className="contact-info-section">
                <h3 className="fw-bold mb-4">
                  <i className="bi bi-info-circle-fill text-warning me-2"></i>
                  Contact Information
                </h3>
                <p className="text-muted mb-4">
                  Reach out to our Software Solutions team to turn your ideas
                  into scalable, reliable products. We're here to build smart
                  solutions that move your business forward.
                </p>

                {/* Office Card */}
                <div className="card border-0 shadow-sm mb-4 contact-card">
                  <div className="card-body p-4">
                    <div className="d-flex align-items-start">
                      <div className="contact-icon-box bg-warning bg-opacity-10 rounded-3 p-3 me-3 flex-shrink-0">
                        <i className="bi bi-geo-alt-fill text-warning fs-4"></i>
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="fw-bold mb-2">
                          <i className="bi bi-building me-2"></i>
                          Office Address
                        </h6>
                        <p className="text-muted small mb-0">
                          Adrija Consultancy Services LLP
                          <br />
                          24, Lane 1, Block A, Aman Vihar
                          <br />
                          Dehradun, Uttarakhand – 248001
                          <br />
                          India
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Phone Card */}
                <div className="card border-0 shadow-sm mb-4 contact-card">
                  <div className="card-body p-4">
                    <div className="d-flex align-items-start">
                      <div className="contact-icon-box bg-warning bg-opacity-10 rounded-3 p-3 me-3 flex-shrink-0">
                        <i className="bi bi-telephone-fill text-warning fs-4"></i>
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="fw-bold mb-2">
                          <i className="bi bi-phone me-2"></i>
                          Phone
                        </h6>
                        <a
                          href="tel:+918860179948"
                          className="text-decoration-none text-dark d-inline-flex align-items-center hover-link"
                        >
                          <i className="bi bi-arrow-right-circle me-2 text-warning"></i>
                          <span className="fw-semibold">+91 88601 79948</span>
                        </a>
                        <p className="text-muted small mb-0 mt-2">
                          <i className="bi bi-clock me-1"></i>
                          Mon-Fri, 9:00 AM - 6:00 PM IST
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Email Card */}
                <div className="card border-0 shadow-sm mb-4 contact-card">
                  <div className="card-body p-4">
                    <div className="d-flex align-items-start">
                      <div className="contact-icon-box bg-warning bg-opacity-10 rounded-3 p-3 me-3 flex-shrink-0">
                        <i className="bi bi-envelope-fill text-warning fs-4"></i>
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="fw-bold mb-2">
                          <i className="bi bi-envelope-at me-2"></i>
                          Email
                        </h6>
                        <a
                          href="mailto:contact@lastmileservice.in"
                          className="text-decoration-none text-dark d-inline-flex align-items-center hover-link"
                        >
                          <i className="bi bi-arrow-right-circle me-2 text-warning"></i>
                          <span className="fw-semibold">
                            contact@lastmileservice.in
                          </span>
                        </a>
                        <p className="text-muted small mb-0 mt-2">
                          <i className="bi bi-lightning-charge-fill me-1"></i>
                          We respond within 24 hours
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Quick Stats */}
                <div className="stats-grid mt-4">
                  <div className="row g-3">
                    <div className="col-6">
                      <div className="stat-box bg-light rounded-3 p-3 text-center">
                        <i className="bi bi-headset text-warning fs-3 mb-2 d-block"></i>
                        <h4 className="fw-bold mb-1 text-warning">24/7</h4>
                        <p className="small text-muted mb-0">
                          Support Available
                        </p>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="stat-box bg-light rounded-3 p-3 text-center">
                        <i className="bi bi-speedometer2 text-warning fs-3 mb-2 d-block"></i>
                        <h4 className="fw-bold mb-1 text-warning">&lt;24h</h4>
                        <p className="small text-muted mb-0">Response Time</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-lg-7">
              <div className="card border-0 shadow-sm">
                <div className="card-body p-4 p-lg-5">
                  <h4 className="fw-bold mb-2">
                    <i className="bi bi-pencil-square text-warning me-2"></i>
                    Send Us a Message
                  </h4>
                  <p className="text-muted mb-4">
                    Fill out the form below and our team will get back to you
                    shortly.
                  </p>

                  <form onSubmit={handleSubmit} noValidate>
                    <div className="row g-3">
                      {/* Name */}
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">
                          <i className="bi bi-person-fill text-warning me-1"></i>
                          Full Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control form-control-lg ${errors.name ? "is-invalid" : ""}`}
                          value={formData.name}
                          onChange={(e) =>
                            setFormData({ ...formData, name: e.target.value })
                          }
                          placeholder="John Doe"
                        />
                        {errors.name && (
                          <div className="invalid-feedback">
                            <i className="bi bi-exclamation-circle me-1"></i>
                            {errors.name}
                          </div>
                        )}
                      </div>

                      {/* Email */}
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">
                          <i className="bi bi-envelope-fill text-warning me-1"></i>
                          Email Address <span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          className={`form-control form-control-lg ${errors.email ? "is-invalid" : ""}`}
                          value={formData.email}
                          onChange={(e) =>
                            setFormData({ ...formData, email: e.target.value })
                          }
                          placeholder="john@company.com"
                        />
                        {errors.email && (
                          <div className="invalid-feedback">
                            <i className="bi bi-exclamation-circle me-1"></i>
                            {errors.email}
                          </div>
                        )}
                      </div>

                      {/* Phone */}
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">
                          <i className="bi bi-telephone-fill text-warning me-1"></i>
                          Phone Number{" "}
                          <span className="text-muted small">(Optional)</span>
                        </label>
                        <input
                          type="tel"
                          className={`form-control form-control-lg ${errors.phone ? "is-invalid" : ""}`}
                          value={formData.phone}
                          onChange={(e) =>
                            setFormData({ ...formData, phone: e.target.value })
                          }
                          placeholder="+91 55555 55555"
                        />
                        {errors.phone && (
                          <div className="invalid-feedback">
                            <i className="bi bi-exclamation-circle me-1"></i>
                            {errors.phone}
                          </div>
                        )}
                      </div>

                      {/* Company */}
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">
                          <i className="bi bi-building text-warning me-1"></i>
                          Company Name{" "}
                          <span className="text-muted small">(Optional)</span>
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          value={formData.company}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              company: e.target.value,
                            })
                          }
                          placeholder="Your Company"
                        />
                      </div>

                      {/* Message */}
                      <div className="col-12">
                        <label className="form-label fw-semibold">
                          <i className="bi bi-chat-left-text-fill text-warning me-1"></i>
                          Project Details <span className="text-danger">*</span>
                        </label>
                        <textarea
                          className={`form-control form-control-lg ${
                            errors.message ? "is-invalid" : ""
                          }`}
                          rows="5"
                          value={formData.message}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              message: e.target.value,
                            })
                          }
                          placeholder="Tell us about your thermal AI detection requirements, timeline, and any specific challenges you're facing..."
                        />
                        {errors.message && (
                          <div className="invalid-feedback">
                            <i className="bi bi-exclamation-circle me-1"></i>
                            {errors.message}
                          </div>
                        )}
                      </div>

                      {/* Submit Button */}
                      <div className="col-12">
                        <button
                          type="submit"
                          className="btn btn-warning btn-lg w-100 fw-semibold"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Sending...
                            </>
                          ) : (
                            <>
                              <i className="bi bi-send-fill me-2"></i>
                              Send Message
                            </>
                          )}
                        </button>
                      </div>

                      {/* Privacy Notice */}
                      <div className="col-12">
                        <p className="text-muted small mb-0 text-center">
                          <i className="bi bi-shield-check me-1 text-success"></i>
                          Your information is secure and will only be used to
                          respond to your inquiry.
                        </p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Info Section */}
        <div className="additional-info-section bg-light py-5">
          <div className="container">
            <div className="row g-4">
              <div className="col-md-4">
                <div className="text-center info-feature-card">
                  <div
                    className="icon-circle bg-warning bg-opacity-10 d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                    style={{ width: "80px", height: "80px" }}
                  >
                    <i className="bi bi-clock-history text-warning fs-3"></i>
                  </div>
                  <h5 className="fw-bold mb-2">Quick Response</h5>
                  <p className="text-muted small mb-0">
                    We typically respond to all inquiries within 24 hours during
                    business days
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="text-center info-feature-card">
                  <div
                    className="icon-circle bg-warning bg-opacity-10 d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                    style={{ width: "80px", height: "80px" }}
                  >
                    <i className="bi bi-calendar-check text-warning fs-3"></i>
                  </div>
                  <h5 className="fw-bold mb-2">Consult Us</h5>
                  <p className="text-muted small mb-0">
                    Schedule a 30-minute consultation to discuss your Project
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="text-center info-feature-card">
                  <div
                    className="icon-circle bg-warning bg-opacity-10 d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                    style={{ width: "80px", height: "80px" }}
                  >
                    <i className="bi bi-headset text-warning fs-3"></i>
                  </div>
                  <h5 className="fw-bold mb-2">Expert Support</h5>
                  <p className="text-muted small mb-0">
                    Connect with our Wonderful team for Software Development
                    Support
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
